
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: "Userpay",
components: {Group, Cell,XHeader},
data() {
return {
payList: [],
role:this.$route.params.role
}
},
created() {
this.payList = this.$route.params.info;
},
}



// WEBPACK FOOTER //
// ./src/components/Pay/Userpay.vue